module.exports = __webpack_public_path__ + "static/media/collection-success-notification-icon.6d6fa161.svg";